import mapProps from '../scripts/utils/map-props';
import Pagination from './pagination';

export default mapProps(
  [
    'index',
    {
      name: 'pageSize',
      event: ['pageSizeChange', 'update:pageSize'],
    },
  ],
  {
    model: {
      prop: 'index',
      event: 'change',
    },
  }
)(Pagination);
